import AjvPkg from 'ajv/dist/2020.js';
import addFormatsPkg from 'ajv-formats';
import remedySchemaJson from '../../../schemas/remedy.schema.json' with { type: 'json' };
export const remedySchema = remedySchemaJson;
// ajv & ajv-formats ship CJS defaults; under NodeNext ESM resolution the
// constructor/callable lives on `.default`. Normalise at runtime.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Ajv = AjvPkg.default ?? AjvPkg;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const addFormats = addFormatsPkg.default ?? addFormatsPkg;
const ajv = new Ajv({ allErrors: true, strict: false });
addFormats(ajv);
export const validateAgainstSchema = ajv.compile(remedySchema);
//# sourceMappingURL=schema.js.map